import DOMPurify from 'dompurify';

/** Sanitize untrusted HTML before rendering it with dangerouslySetInnerHTML. */
export const sanitizeHtml = (html: string): string => DOMPurify.sanitize(html || '');

/** Escape text for safe interpolation into an HTML string (e.g. print windows). */
export const escapeHtml = (text: unknown): string =>
  String(text ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
